import React from 'react';

// eslint-disable-next-line import/no-cycle
import {routes} from "./routes";

const RouteList = () => {
    const getRoutes = (r: any) => {
        return r.map((route: any) => {
            const allPaths = [];
            if (route.path) {
                allPaths.push(route.path);
            }

            if (route.children) {
                const children = getRoutes(route.children).map((child: any) => {
                    return `/${child}`;
                });
                allPaths.push(...children);
            }

            return allPaths;
        });
    }

    return (
        <>
            <h1>Index page</h1>
            <ul>
                <li><a href="#/">Home</a></li>
                <li><a href="#/other-page">Other Page</a></li>
                <li><a href="#/other-page/123">Other Page / Other page 2</a></li>
                <li><a href="#/other-page-2/1234">Other Page 2</a></li>
            </ul>

            <h2>All routes</h2>
            <ul>
                { getRoutes(routes[0].children).map((route: any) => {
                    return <li key={route}><a href={`#${route}`}>{route}</a></li>
                })}
            </ul>
        </>
    );
}

export default RouteList;

